import firebase from 'Firebase'

const state = {
  user: null,
  userImage: null,
  userData: null,
  error: null,
  logged: null,
}

const mutations = {
  RESET_USER: function (state) {
    state.user = null;
    state.userData = null;
  },
  SET_USER: function (state, user) {
    state.user = user;
  },
  SET_USER_LOGGED: function (state, logged) {
    state.logged = logged;
  },
  SET_USER_IMAGE: function (state, image) {
    state.userImage = image;
  },
  SET_ERROR: function (state, err) {
    state.error = err;
  },
}

const actions = {

  verifyLogin({ state, commit, rootState }, uid) {

    return new Promise((resolve, reject) => {

      commit('SET_DATABASE');

      rootState.Database.db
        .collection("users")
        .doc(uid)
        .get()
        .then(function (doc) {
          if (doc.exists) {
            if (doc.data().role === "user") {
              /* console.log("User ok") */
              let b = doc.data();
              b["id"] = uid;
              rootState.Database.storage.refFromURL(b.image).getDownloadURL().then(function (url) {
                var xhr = new XMLHttpRequest();
                xhr.responseType = 'blob';
                xhr.onload = function (event) {
                  var blob = xhr.response;
                };
                xhr.open('GET', url);
                xhr.send();
                commit('SET_USER_IMAGE', url)
              }).catch(function (error) {
                // Handle any errors
              });
              resolve(b);
            }
            else {
              reject("Not an user");
            }
          }
          else {
            reject("No documents found for the user");
          }
        })
    })

  },
  login({ commit, rootState }, data) {
    firebase.auth().signInWithEmailAndPassword(data.email, data.password).then(user => {
      /* console.log(user); */
    }).catch(function (error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      commit('SET_ERROR', error.message)
    });
  },
  logout() {
    firebase.auth().signOut().then(function () {
     /*  console.log("Log out successful") */
    }).catch(function (error) {
      // An error happened.
    });
  },
  setLogged({commit}, logged) {
    commit('SET_USER_LOGGED',logged);
  }
}

const getters = {
  getUser(state) {
    return state.user;
  },
  getLoggedState(state) {
    return state.logged;
  },
  getUserImage(state) {
    return state.userImage;
  },
  getUserId(state) {
    if (state.user != null) {
      return state.user.uid;
    }

  },
  getErrorMessage(state) {
    return state.error;
  }
}

export default {
  state,
  getters,
  actions,
  mutations
} 



// WEBPACK FOOTER //
// ./src/store/modules/User.js